module.exports = __webpack_public_path__ + "img/icp-scan.93ebc5a1.svg";